export default {
  DUPLICATE: {
    label: 'Duplicate',
    value: 'DUPLICATE',
  },
  FRAUDULENT: {
    label: 'Fraudulent',
    value: 'FRAUDULENT',
  },
  REQUESTED_BY_CUSTOMER: {
    label: 'Requested by customer',
    value: 'REQUESTED_BY_CUSTOMER',
  },
  POSTPONED: {
    label: 'Postponed',
    value: 'POSTPONED',
  },
  BAD_EXPERIENCE: {
    label: 'Bad experience',
    value: 'BAD_EXPERIENCE',
  },
  NO_SHOW_AND_BLOCK_USER: {
    label: 'No show and block user',
    value: 'NO_SHOW_AND_BLOCK_USER',
  },
  NO_SHOW: {
    label: 'No show',
    value: 'NO_SHOW',
  },
  BAD_WEATHER: {
    label: 'Bad weather',
    value: 'BAD_WEATHER',
  },
  LATE_CANCELLATION: {
    label: 'Late cancellation',
    value: 'LATE_CANCELLATION',
  },
  WRONG_RESTAURANT_BOOKED: {
    label: 'Wrong restaurant booked',
    value: 'WRONG_RESTAURANT_BOOKED',
  },
  FULLY_BOOKED_OUT: {
    label: 'Fully booked out',
    value: 'FULLY_BOOKED_OUT',
  },
  OTHER: {
    label: 'Other',
    value: 'OTHER',
  },
};
